// Lightweight i18n with three languages: UA (default), RU, EN
import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "./api";

const dict = {
  ua: {
    nav: { services: "Послуги", gallery: "Галерея", about: "Про нас", faq: "Поширені питання", contact: "Контакти", consult: "Консультація" },
    cta: { call: "Зателефонувати", request: "Замовити послугу", inspection: "Безкоштовний огляд", view_works: "Переглянути роботи", login: "Увійти", register: "Реєстрація", logout: "Вийти", dashboard: "Кабінет", send: "Надіслати заявку", more: "Детальніше", submit: "Надіслати", admin: "Адмін" },
    hero: { eyebrow: "Преміальний догляд за натуральним каменем", title_1: "Джавала", title_2: "Мрамор", subtitle: "Полірування, реставрація та захист мармуру по всій Україні. Архітектурна точність. 20 років досвіду. Гарантія 2 роки.", scroll: "Гортати" },
    stats: { years: ["20+", "років досвіду"], objects: ["1 183", "обʼєктів"], warranty: ["2 роки", "гарантії"] },
    services: {
      eyebrow: "Що ми робимо",
      title_1: "Наші",
      title_2: "послуги",
      lead: "Повний спектр робіт з догляду за мармуром та натуральним каменем — від регулярного обслуговування до повної реставрації.",
      list: [
        { t: "Полірування мармуру", d: "Відновлення природного блиску без хімічної агресії. Алмазні інструменти та безпечні засоби." },
        { t: "Чищення та знежирення", d: "Видалення плям, бруду, залишків будматеріалів. Глибоке очищення без пошкодження структури." },
        { t: "Захисна просочення", d: "Нанесення імпрегнату для захисту від вологи та бруду. Ефект до 5 років." },
        { t: "Реставрація та шліфування", d: "Усунення подряпин, сколів, матових ділянок. Повернення каменю первісного вигляду." },
        { t: "Кристалізація мармуру", d: "Надглибокий дзеркальний блиск. Хімічна реакція, що зміцнює верхній шар." },
        { t: "Мозаїка та травертин", d: "Спеціалізована обробка складних поверхонь. Заповнення пор, затирка швів, захист рельєфу." },
        { t: "Установка поверхонь", d: "Укладання, монтаж стільниць, підлог, сходів. Точна підгонка та герметизація стиків." },
        { t: "Безкоштовна консультація", d: "Виїзна оцінка стану покриття, рекомендації та кошторис без зобовʼязань." },
      ],
    },
    why: {
      eyebrow: "Наші переваги",
      title_1: "Чому обирають",
      title_2: "Джавала",
      list: [
        { t: "Сертифіковані майстри", d: "20 років практики на сотнях найскладніших обʼєктів. Знаємо кожен тип каменю." },
        { t: "Власне обладнання", d: "Професійна техніка Klindex та Husqvarna. Без субпідрядників — повний контроль якості." },
        { t: "Професійні матеріали", d: "Сертифіковані просочення, поліролі та інструменти від провідних світових виробників." },
        { t: "По всій Україні", d: "Виїжджаємо до Києва, Харкова, Одеси, Львова та 30+ міст. Гарантія 2 роки на всі роботи." },
      ],
    },
    gallery: {
      eyebrow: "Портфоліо",
      title_1: "Наші",
      title_2: "роботи",
      tabs: ["Усі", "Підлоги", "Стільниці", "Інтерʼєри", "Каміни", "Деталі"],
      ba_label: "Перетягніть розділювач — порівняйте результат",
      before: "До",
      after: "Після",
    },
    process: {
      eyebrow: "Як ми працюємо",
      title_1: "Простий та",
      title_2: "прозорий процес",
      list: [
        { t: "Заявка", d: "Телефонуйте або заповніть форму. Відповідаємо протягом 30 хвилин." },
        { t: "Огляд", d: "Безкоштовна оцінка стану покриття та розрахунок вартості." },
        { t: "Договір", d: "Фіксована вартість без прихованих доплат. Чіткі терміни." },
        { t: "Виконання", d: "Акуратно, без пилу. Захист меблів та прилеглих поверхонь." },
        { t: "Гарантія", d: "Перевірка якості разом із замовником. Гарантія на 2 роки." },
      ],
    },
    testimonials: {
      eyebrow: "Клієнти",
      title_1: "Відгуки",
      title_2: "замовників",
      list: [
        { q: "Відновили мармур у ванній, якому вже 15 років. Виглядає як новий! Все зробили охайно, без пилу і бруду.", n: "Олена Коваленко", c: "Київ · Приватна квартира" },
        { q: "Приїхали вчасно, працювали акуратно. Стільниця з чорного мармуру блищить ідеально.", n: "Ресторан \"Аркада\"", c: "Харків · Ресторан" },
        { q: "Реставрація мармурових сходів в офісному центрі. Результат перевершив очікування.", n: "Михайло Сидоренко", c: "Одеса · Офісний центр" },
        { q: "Після ремонту підлога була вся в плямах. Джавала зробили все ідеально за один день!", n: "Наталія Вовченко", c: "Львів · Приватний будинок" },
        { q: "Чіткий підхід: огляд, розрахунок, договір, виконання в строк. Наш готель тепер завжди сяє.", n: "Готель \"Палас\"", c: "Дніпро · Готель 5★" },
      ],
    },
    faq: {
      eyebrow: "Питання та відповіді",
      title_1: "Часті",
      title_2: "запитання",
      list: [
        { q: "Скільки часу займає полірування мармуру?", a: "Залежить від площі та стану поверхні. Кімната 20–30 м² — зазвичай 4–8 годин. Великі обʼєкти можуть займати кілька днів. Точний термін фіксуємо в договорі." },
        { q: "Чи залишається пил та бруд після роботи?", a: "Ні. Ми використовуємо шліфувальні машини з вбудованою системою водовідведення та пилозбору. Меблі захищаємо плівкою. Після завершення — прибираємо повністю." },
        { q: "Чи можна полірувати мармур у квартирі з жильцями?", a: "Так. Наші матеріали безпечні для людей та домашніх тварин. Можемо організувати роботу посекційно, щоб мінімально заважати вашому ритму життя." },
        { q: "Яка гарантія на роботи?", a: "Ми надаємо офіційну письмову гарантію на 2 роки. Якщо зʼявились проблеми через якість нашої роботи — усунемо безкоштовно." },
        { q: "Чи виїжджаєте ви до інших міст?", a: "Так, по всій Україні. Київ, Харків, Одеса, Львів, Дніпро та інші міста — наша географія." },
        { q: "Як часто потрібно полірувати мармур?", a: "Для квартир — раз на 3–5 років. Для ресторанів та готелів — раз на рік або частіше. Після нанесення захисного просочення мармур значно довше зберігає блиск." },
      ],
    },
    geo: { eyebrow: "Географія", title_1: "Працюємо по всій", title_2: "Україні", lead: "Виїзд до вашого обʼєкту без додаткових витрат у межах міста." },
    contact: {
      eyebrow: "Звʼяжіться з нами",
      title_1: "Замовити послугу або",
      title_2: "консультацію",
      lead: "Зателефонуйте або залиште заявку — звʼяжемося протягом 30 хвилин та організуємо безкоштовний виїзний огляд.",
      name: "Ваше імʼя",
      phone: "Телефон",
      email: "Email (за бажанням)",
      city: "Місто",
      service: "Тип послуги",
      message: "Повідомлення",
      sent: "Дякуємо! Ми звʼяжемося з вами протягом 30 хвилин.",
    },
    auth: {
      login_title: "Вхід до кабінету",
      register_title: "Створити акаунт",
      email: "Email",
      password: "Пароль",
      name: "Імʼя та прізвище",
      phone: "Телефон",
      no_account: "Ще немає акаунту?",
      have_account: "Вже є акаунт?",
      sign_up: "Зареєструватись",
      sign_in: "Увійти",
      google: "Увійти через Google",
      or: "або",
    },
    dashboard: {
      hi: "Вітаємо",
      profile: "Профіль",
      orders: "Мої заявки",
      settings: "Налаштування",
      no_orders: "У вас поки немає заявок. Залишайте заявку на головній сторінці.",
      status: { new: "Нова", in_progress: "В роботі", scheduled: "Заплановано", completed: "Виконано", cancelled: "Скасовано" },
      save: "Зберегти",
      saved: "Збережено",
      lang_label: "Мова інтерфейсу",
    },
    admin: {
      title: "Адмін-панель",
      leads: "Заявки",
      total: "Всього",
      filter_all: "Усі",
      empty: "Заявок немає",
      cols: { date: "Дата", contact: "Контакт", city: "Місто", service: "Послуга", message: "Повідомлення", source: "Джерело", status: "Статус" },
    },
    floating: { call: "Зателефонувати" },
    leadpopup: {
      eyebrow: "Безкоштовний",
      title: "виїзний огляд",
      lead: "Залиште телефон — перетелефонуємо протягом 30 хвилин та домовимося про зручний час огляду.",
      btn: "Замовити безкоштовний огляд",
      foot: "Без зобовʼязань. Тільки консультація.",
    },
  },
  ru: {
    nav: { services: "Услуги", gallery: "Галерея", about: "О нас", faq: "Вопросы", contact: "Контакты", consult: "Консультация" },
    cta: { call: "Позвонить", request: "Заказать услугу", inspection: "Бесплатный осмотр", view_works: "Смотреть работы", login: "Войти", register: "Регистрация", logout: "Выйти", dashboard: "Кабинет", send: "Отправить заявку", more: "Подробнее", submit: "Отправить", admin: "Админ" },
    hero: { eyebrow: "Премиальный уход за натуральным камнем", title_1: "Джавала", title_2: "Мрамор", subtitle: "Полировка, реставрация и защита мрамора по всей Украине. Архитектурная точность. 20 лет опыта. Гарантия 2 года.", scroll: "Листать" },
    stats: { years: ["20+", "лет опыта"], objects: ["1 183", "объектов"], warranty: ["2 года", "гарантии"] },
    services: { eyebrow: "Что мы делаем", title_1: "Наши", title_2: "услуги", lead: "Полный спектр работ по уходу за мрамором и натуральным камнем.", list: [
      { t: "Полировка мрамора", d: "Восстановление природного блеска без химической агрессии." },
      { t: "Чистка и обезжиривание", d: "Удаление пятен, грязи, остатков стройматериалов." },
      { t: "Защитная пропитка", d: "Нанесение импрегната. Эффект до 5 лет." },
      { t: "Реставрация и шлифовка", d: "Устранение царапин, сколов, матовых участков." },
      { t: "Кристаллизация мрамора", d: "Сверхглубокий зеркальный блеск." },
      { t: "Мозаика и травертин", d: "Специальная обработка сложных поверхностей." },
      { t: "Установка поверхностей", d: "Укладка столешниц, полов, лестниц." },
      { t: "Бесплатная консультация", d: "Выездная оценка и смета без обязательств." },
    ] },
    why: { eyebrow: "Наши преимущества", title_1: "Почему выбирают", title_2: "Джавала", list: [
      { t: "Сертифицированные мастера", d: "20 лет практики на сотнях сложнейших объектов. Знаем каждый тип камня." },
      { t: "Собственное оборудование", d: "Профессиональная техника Klindex и Husqvarna. Без субподрядчиков." },
      { t: "Профессиональные материалы", d: "Сертифицированные пропитки, полироли и инструменты от ведущих мировых производителей." },
      { t: "По всей Украине", d: "Выезжаем в 30+ городов. Гарантия 2 года на все работы." },
    ] },
    gallery: { eyebrow: "Портфолио", title_1: "Наши", title_2: "работы", tabs: ["Все", "Полы", "Столешницы", "Интерьеры", "Камины", "Детали"], ba_label: "Перетащите разделитель — сравните результат", before: "До", after: "После" },
    process: { eyebrow: "Как мы работаем", title_1: "Простой и", title_2: "прозрачный процесс", list: [
      { t: "Заявка", d: "Звоните или оставьте форму. Отвечаем в течение 30 минут." },
      { t: "Осмотр", d: "Бесплатная оценка и расчёт стоимости." },
      { t: "Договор", d: "Фиксированная стоимость без скрытых доплат." },
      { t: "Выполнение", d: "Аккуратно, без пыли." },
      { t: "Гарантия", d: "Проверка качества вместе с заказчиком." },
    ] },
    testimonials: { eyebrow: "Клиенты", title_1: "Отзывы", title_2: "заказчиков", list: [
      { q: "Восстановили мрамор в ванной, которой 15 лет. Выглядит как новый!", n: "Елена Коваленко", c: "Киев · Квартира" },
      { q: "Приехали вовремя, работали аккуратно.", n: "Ресторан \"Аркада\"", c: "Харьков · Ресторан" },
      { q: "Реставрация мраморных лестниц превзошла ожидания.", n: "Михаил Сидоренко", c: "Одесса · Офис" },
      { q: "После ремонта полы были в пятнах. Джавала сделали идеально за один день!", n: "Наталья Вовченко", c: "Львов · Дом" },
      { q: "Чёткий подход: осмотр, договор, выполнение в срок.", n: "Отель \"Палас\"", c: "Днепр · Отель 5★" },
    ] },
    faq: { eyebrow: "Вопросы и ответы", title_1: "Частые", title_2: "вопросы", list: [
      { q: "Сколько занимает полировка мрамора?", a: "Комната 20–30 м² — 4–8 часов. Точные сроки в договоре." },
      { q: "Остаётся ли пыль после работы?", a: "Нет. Используем системы пылеудаления и водоотведения." },
      { q: "Можно полировать в квартире с жильцами?", a: "Да, материалы безопасны." },
      { q: "Какая гарантия?", a: "Письменная гарантия 2 года." },
      { q: "Выезжаете в другие города?", a: "Да, по всей Украине." },
      { q: "Как часто полировать?", a: "Квартиры — раз в 3–5 лет." },
    ] },
    geo: { eyebrow: "География", title_1: "Работаем по всей", title_2: "Украине", lead: "Выезд к вашему объекту в пределах города без доплат." },
    contact: { eyebrow: "Свяжитесь с нами", title_1: "Заказать услугу или", title_2: "консультацию", lead: "Позвоните или оставьте заявку — свяжемся в течение 30 минут.", name: "Ваше имя", phone: "Телефон", email: "Email (по желанию)", city: "Город", service: "Тип услуги", message: "Сообщение", sent: "Спасибо! Свяжемся в течение 30 минут." },
    auth: { login_title: "Вход в кабинет", register_title: "Создать аккаунт", email: "Email", password: "Пароль", name: "Имя и фамилия", phone: "Телефон", no_account: "Ещё нет аккаунта?", have_account: "Уже есть аккаунт?", sign_up: "Зарегистрироваться", sign_in: "Войти", google: "Войти через Google", or: "или" },
    dashboard: { hi: "Здравствуйте", profile: "Профиль", orders: "Мои заявки", settings: "Настройки", no_orders: "У вас пока нет заявок.", status: { new: "Новая", in_progress: "В работе", scheduled: "Запланировано", completed: "Выполнено", cancelled: "Отменено" }, save: "Сохранить", saved: "Сохранено", lang_label: "Язык интерфейса" },
    admin: { title: "Админ-панель", leads: "Заявки", total: "Всего", filter_all: "Все", empty: "Заявок нет", cols: { date: "Дата", contact: "Контакт", city: "Город", service: "Услуга", message: "Сообщение", source: "Источник", status: "Статус" } },
    floating: { call: "Позвонить" },
    leadpopup: { eyebrow: "Бесплатный", title: "выездной осмотр", lead: "Оставьте телефон — перезвоним в течение 30 минут.", btn: "Заказать осмотр", foot: "Без обязательств." },
  },
  en: {
    nav: { services: "Services", gallery: "Gallery", about: "About", faq: "FAQ", contact: "Contact", consult: "Consultation" },
    cta: { call: "Call now", request: "Request a service", inspection: "Free inspection", view_works: "View works", login: "Sign in", register: "Sign up", logout: "Sign out", dashboard: "Dashboard", send: "Send request", more: "Read more", submit: "Send", admin: "Admin" },
    hero: { eyebrow: "Premium care for natural stone", title_1: "Dzhavala", title_2: "Marmor", subtitle: "Polishing, restoration and protection of marble across Ukraine. Architectural precision. 20 years of experience. 2-year warranty.", scroll: "Scroll" },
    stats: { years: ["20+", "years of experience"], objects: ["1,183", "objects done"], warranty: ["2 years", "warranty"] },
    services: { eyebrow: "What we do", title_1: "Our", title_2: "services", lead: "Full spectrum of marble & natural stone care — from routine maintenance to full restoration.", list: [
      { t: "Marble polishing", d: "Restoring natural shine without harsh chemistry." },
      { t: "Cleaning & degreasing", d: "Stains, dirt, construction residue removal." },
      { t: "Protective impregnation", d: "Up to 5 years of moisture & dirt protection." },
      { t: "Restoration & grinding", d: "Scratches, chips, dull spots fully restored." },
      { t: "Crystallization", d: "Ultra-deep mirror shine, surface hardening." },
      { t: "Mosaic & travertine", d: "Specialized care for complex surfaces." },
      { t: "Surface installation", d: "Counters, floors, stairs precisely fitted." },
      { t: "Free consultation", d: "On-site assessment and quote, zero commitment." },
    ] },
    why: { eyebrow: "Why us", title_1: "Why clients choose", title_2: "Dzhavala", list: [
      { t: "Certified masters", d: "20 years of practice on hundreds of complex projects. We know every type of stone." },
      { t: "Own equipment", d: "Professional Klindex & Husqvarna machinery. No subcontractors — full quality control." },
      { t: "Professional materials", d: "Certified impregnators, polishes and tools from leading world manufacturers." },
      { t: "Across Ukraine", d: "Kyiv, Kharkiv, Odesa, Lviv & 30+ cities. 2-year warranty on all work." },
    ] },
    gallery: { eyebrow: "Portfolio", title_1: "Selected", title_2: "works", tabs: ["All", "Floors", "Counters", "Interiors", "Fireplaces", "Details"], ba_label: "Drag the divider to compare", before: "Before", after: "After" },
    process: { eyebrow: "How we work", title_1: "A simple and", title_2: "transparent process", list: [
      { t: "Request", d: "Call us or fill the form. We respond within 30 min." },
      { t: "Inspection", d: "Free on-site assessment & quote." },
      { t: "Contract", d: "Fixed price, no hidden costs." },
      { t: "Execution", d: "Tidy, dustless, with full furniture protection." },
      { t: "Warranty", d: "Quality check with the client. 2-yr written warranty." },
    ] },
    testimonials: { eyebrow: "Clients", title_1: "Testimonials", title_2: "from our clients", list: [
      { q: "They restored 15-year-old bathroom marble — looks brand new.", n: "Olena Kovalenko", c: "Kyiv · Apartment" },
      { q: "On time, neat work. The black countertop shines flawlessly.", n: "Arkada restaurant", c: "Kharkiv · Restaurant" },
      { q: "Marble stairs restoration exceeded expectations.", n: "Mykhailo Sydorenko", c: "Odesa · Office" },
      { q: "After renovation our floor was full of stains. Dzhavala made it perfect in one day.", n: "Nataliya Vovchenko", c: "Lviv · House" },
      { q: "Crystal-clear approach: inspection, contract, on-time delivery.", n: "Palace Hotel", c: "Dnipro · 5★ Hotel" },
    ] },
    faq: { eyebrow: "FAQ", title_1: "Frequently", title_2: "asked questions", list: [
      { q: "How long does marble polishing take?", a: "Typically 4–8 hours for a 20–30 m² room. Locked in the contract." },
      { q: "Will there be dust?", a: "No — we use water-cooled, dust-free machines." },
      { q: "Can it be done while we live in the apartment?", a: "Yes, our materials are safe for people and pets." },
      { q: "What is the warranty?", a: "A written 2-year warranty covers our work." },
      { q: "Do you travel outside Kyiv?", a: "Yes, throughout Ukraine." },
      { q: "How often should marble be polished?", a: "Apartments: every 3–5 years." },
    ] },
    geo: { eyebrow: "Geography", title_1: "Working all over", title_2: "Ukraine", lead: "On-site visits within city limits at no extra cost." },
    contact: { eyebrow: "Get in touch", title_1: "Request a service or", title_2: "consultation", lead: "Call us or leave a request — we'll get in touch within 30 minutes.", name: "Your name", phone: "Phone", email: "Email (optional)", city: "City", service: "Service", message: "Message", sent: "Thanks! We'll be in touch within 30 minutes." },
    auth: { login_title: "Sign in", register_title: "Create account", email: "Email", password: "Password", name: "Full name", phone: "Phone", no_account: "No account yet?", have_account: "Already have an account?", sign_up: "Sign up", sign_in: "Sign in", google: "Continue with Google", or: "or" },
    dashboard: { hi: "Hello", profile: "Profile", orders: "My requests", settings: "Settings", no_orders: "No requests yet.", status: { new: "New", in_progress: "In progress", scheduled: "Scheduled", completed: "Completed", cancelled: "Cancelled" }, save: "Save", saved: "Saved", lang_label: "Interface language" },
    admin: { title: "Admin", leads: "Requests", total: "Total", filter_all: "All", empty: "No requests", cols: { date: "Date", contact: "Contact", city: "City", service: "Service", message: "Message", source: "Source", status: "Status" } },
    floating: { call: "Call us" },
    leadpopup: { eyebrow: "Free", title: "on-site inspection", lead: "Leave your phone — we'll call back within 30 minutes.", btn: "Book free inspection", foot: "No commitment. Just a chat." },
  },
};

const I18nContext = createContext({ t: dict.ua, lang: "ua", setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("lang") || "ua");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // setLang persists to backend if user is authenticated
  const setLang = React.useCallback(async (next) => {
    if (!dict[next]) return;
    setLangState(next);
    try {
      // Only attempt to save if we have a session — otherwise endpoint returns 401 quietly
      await api.patch("/auth/profile", { lang: next });
    } catch {
      // anonymous user — silently ignore
    }
  }, []);

  const value = useMemo(() => ({ t: dict[lang] || dict.ua, lang, setLang, setLangLocal: setLangState }), [lang, setLang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
